import CountdownBannerMicro from "./variants/Micro";
import CountdownBannerCta from "./variants/Cta";
import CountdownBannerCtaCompact from "./variants/CtaCompact";
import { CountdownBannerProps } from "./types";
import getCountdownTime from "@/utils/functions/getCountdownTime";

export default function CountdownBanner({
  variant,
  theme,
  header,
  subHeader,
  showSubheader = true,
  targetDate,
  htmlId,
  location,
  name,
  position,
  className,
  showCTA,
  ctaElement,
  tooltip,
}: CountdownBannerProps) {
  const countdownTime = getCountdownTime(targetDate);
  if (!countdownTime) {
    return null;
  }

  switch (variant) {
    case "micro":
      return (
        <CountdownBannerMicro
          theme={theme}
          header={header}
          countdownTime={countdownTime}
          htmlId={htmlId}
          location={location}
          name={name}
          position={position}
          className={className}
        />
      );
    case "cta":
      return (
        <CountdownBannerCta
          theme={theme}
          header={header}
          subHeader={subHeader ?? ""}
          showSubheader={showSubheader}
          countdownTime={countdownTime}
          htmlId={htmlId}
          location={location}
          name={name}
          position={position}
          showCTA={showCTA}
          ctaElement={ctaElement}
          tooltip={tooltip}
        />
      );
    case "cta-compact":
      return (
        <CountdownBannerCtaCompact
          theme={theme}
          header={header}
          subHeader={subHeader ?? ""}
          showSubheader={showSubheader}
          countdownTime={countdownTime}
          htmlId={htmlId}
          location={location}
          name={name}
          position={position}
          showCTA={showCTA}
          ctaElement={ctaElement}
          tooltip={tooltip}
        />
      );
    default:
      return null;
  }
}
